import { MY_ADDRESSES } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = MY_ADDRESSES;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Settings,
    social: false,
    showInLoginMenu: true,
    method: 'addApplication',
    urlOverride: 'my-addresses',
    uninstallable: true,
    page: {
        name: t('memberPages.addModal.memberPagesTab.addresses.title'),
        shortDescription: t('memberPages.addModal.memberPagesTab.addresses.body'),
        origin: t('memberPages.addModal.memberPagesTab.by.stores.label'),
        description: formatDescription({
            text: t('memberPages.addModal.memberPagesTab.addresses.description.body'),
            bulletPoints: [
                t('memberPages.addModal.memberPagesTab.addresses.description.bullet1'),
                t('memberPages.addModal.memberPagesTab.addresses.description.bullet2'),
            ],
        }),
        iconURL: `${staticsUrl}assets/images/icons/stores-icon.png`,
        screenshots: [
            `${staticsUrl}assets/images/my-addresses/my-addresses.png`,
            `${staticsUrl}assets/images/my-addresses/my-addresses-2.png`,
            `${staticsUrl}assets/images/my-addresses/my-addresses-3.png`,
            `${staticsUrl}assets/images/my-addresses/mobile-my-addresses.png`,
            `${staticsUrl}assets/images/my-addresses/mobile-my-addresses-2.png`,
        ],
    },
});
//# sourceMappingURL=my-addresses.js.map